/* eslint-disable sorare/no-detached-fragments */
import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { CardAvatar } from '@sorare/core/src/components/card/Avatar';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  UpsertTaskAppearances,
  UpsertTaskAppearancesVariables,
} from './__generated__/useUpsertTaskAppearances.graphql.ts';

const UPSERT_TASK_APPEARANCES_MUTATION = gql`
  mutation UpsertTaskAppearances($input: upsertTaskAppearancesInput!) {
    upsertTaskAppearances(input: $input) {
      task {
        id
        ... on DecisivePlayerPickerTask {
          id
          taskAppearances {
            id
            index
            locked
            card {
              slug
              ...CardAvatar_anyCard
            }
            playerGameScore {
              id
              score
              scoreStatus
              anyGame {
                id
                statusTyped
              }
              ... on PlayerGameScore {
                scoreStatus
                id
                positiveDecisiveStats {
                  stat
                }
              }
            }
            ... on DecisivePlayerPickerTaskAppearance {
              id
              status
            }
          }
        }
        rewardConfigs {
          id
          ... on InGameCurrencyRewardConfig {
            id
            amount
            currency
          }
        }
      }
      errors {
        message
      }
    }
  }
  ${/* eslint-disable-next-line sorare/no-detached-fragments */ ''}
  ${CardAvatar.fragments.anyCard}
` as TypedDocumentNode<UpsertTaskAppearances, UpsertTaskAppearancesVariables>;

export const useUpsertTaskAppearances = () => {
  return useMutation(UPSERT_TASK_APPEARANCES_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
